// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KGXW","content":"styles_content__1o_lZ"};